<template>
  <div class="layer searchPlace">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="cancelLayer"><span class="blind">close</span></button>
      <div class="layerTitle">{{locale.mobility_destination_input}}</div>
      <SearchPlace
        :locale="locale"
        @select="selectLocation" />
      <!--
      <DaumPost
        :locale="locale"
        @select="selectLocation" />
      -->

    </div>
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'
import DaumPost from '@/components/Maps/DaumPost'
import SearchPlace from '@/components/Maps/SearchPlace'

export default {
  name: 'NaverSearch',
  props: [
    'locale'
  ],
  components: {
    Toast,
    DaumPost,
    SearchPlace
  },
  created () {

  },
  data () {
    return {
      word: '',
      result: [],
      toastList: []
    }
  },
  methods: {
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'closeToast') {
            this.delToast()
          } else if (trigger === 'cancelSetLayer') {
            this.closeLayer()
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
          this.delToast()
        }
      }
    },
    closeLayer () {
      this.word = ''
      this.delToast()
      this.$emit('close')
    },
    cancelLayer () {
      this.addToast('cancelSetLayer', 'confirm', this.locale.confirm_cancel)
    },
    selectLocation (data) {
      this.$emit('selectLocation', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  padding-top: 80px;
  padding-bottom: 30px;
  & > .inner {
    height: 100%;
    padding-top: 30px;
  }
}
.searchBox {
  display: flex;
  margin-bottom: 30px;
  .input {
    border-radius: 8px;
  }
  .btn {
    margin-left: 8px;
    border-radius: 8px;
  }
}
@media (min-width: 768px) {
  .layer {
    padding-top: 30px;
    & > .inner {
      padding: 30px;
    }
  }
}
</style>
